export const emptyRequestAccessState = {
  bps: [],
  requests: [],
  pending: [],
  pendingEstates: [],
  estateResults: []
}
